import React, { useState, useEffect } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { ProdutoTable } from '../components/produto/ProdutoTable';
import { ProdutoFormModal } from '../components/produto/ProdutoFormModal';
import type { Produto } from '../types/entities';

export const Produtos: React.FC = () => {
  const [selectedProduto, setSelectedProduto] = useState<Produto | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreateNew = () => {
    setSelectedProduto(undefined);
    setModalOpen(true);
  };

  const handleEdit = (produto: Produto) => {
    setSelectedProduto(produto);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setSelectedProduto(undefined);
    // Força refresh da tabela
    setRefreshTrigger(prev => prev + 1);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedProduto(undefined);
  };

  useEffect(() => {
    // Este efeito será chamado sempre que refreshTrigger mudar
  }, [refreshTrigger]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-4 gap-2">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-bold" style={{ color: '#3d2b56' }}>
                Gestão de Produtos
              </h1>
              <p className="text-xs mt-0.5" style={{ color: '#9E9E9E' }}>
                Gerencie os produtos disponíveis no sistema
              </p>
            </div>

            <button
              onClick={handleCreateNew}
              className="px-3 py-1 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-1 focus:ring-offset-1 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Novo Produto
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <ProdutoTable
              onEdit={handleEdit}
              refreshKey={refreshTrigger}
              onDeleted={() => setRefreshTrigger(prev => prev + 1)}
            />

            {modalOpen && (
              <ProdutoFormModal
                produto={selectedProduto}
                onClose={handleCancel}
                onSuccess={handleSuccess}
              />
            )}
          </div>
        </div>

        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};